export default function ClinicFlowDiagram() {
    return (
        <div className="w-full bg-gradient-to-br from-slate-50 via-white to-gray-50">
            <svg viewBox="0 0 850 700" className="w-full h-auto">
                <defs>
                    <marker id="arrowGray3" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#9ca3af" />
                    </marker>
                    <marker id="arrowBlue3" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#2CABCC" />
                    </marker>
                    <marker id="arrowGreen3" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#22c55e" />
                    </marker>
                </defs>

                {/* Clinic Portal */}
                <rect x="20" y="270" width="80" height="35" rx="6" fill="#fbbf24" />
                <text x="60" y="292" textAnchor="middle" fontSize="10" fontWeight="600" fill="#1f2937">Clinic Portal</text>

                {/* Main vertical line from Clinic Portal */}
                <line x1="100" y1="287" x2="120" y2="287" stroke="#9ca3af" strokeWidth="2" />
                <line x1="120" y1="45" x2="120" y2="640" stroke="#9ca3af" strokeWidth="2" />

                {/* BP APIs */}
                <rect x="550" y="255" width="70" height="50" rx="6" fill="#ef4444" />
                <text x="585" y="285" textAnchor="middle" fontSize="11" fontWeight="700" fill="white">BP APIs</text>

                {/* Main vertical line going to BP APIs */}
                <line x1="550" y1="280" x2="520" y2="280" stroke="#2CABCC" strokeWidth="2" />
                <line x1="520" y1="50" x2="520" y2="640" stroke="#2CABCC" strokeWidth="2" />

                {/* === Row 1: QR Code === */}
                <path d="M 120 50 L 150 50" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="32" width="90" height="35" rx="6" fill="#2CABCC" />
                <text x="205" y="54" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">QR Code</text>

                {/* QR Code to main line */}
                <line x1="250" y1="50" x2="520" y2="50" stroke="#2CABCC" strokeWidth="2" />
                <text x="380" y="42" fontSize="8" fill="#6b7280" fontWeight="500">READ</text>

                {/* Clinical Notes (top right) */}
                <rect x="680" y="32" width="90" height="35" rx="6" fill="#22c55e" />
                <text x="725" y="54" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Clinical Notes</text>
                <line x1="620" y1="50" x2="670" y2="50" stroke="#2CABCC" strokeWidth="2" markerEnd="url(#arrowBlue3)" />
                <line x1="620" y1="50" x2="620" y2="130" stroke="#2CABCC" strokeWidth="2" />

                {/* AI Assistant (top right) */}
                <rect x="680" y="75" width="110" height="35" rx="6" fill="#22c55e" />
                <text x="735" y="92" textAnchor="middle" fontSize="9" fontWeight="600" fill="white">AI Assistant/ Pre-</text>
                <text x="735" y="102" textAnchor="middle" fontSize="9" fontWeight="600" fill="white">Consultant</text>
                <line x1="620" y1="92" x2="670" y2="92" stroke="#2CABCC" strokeWidth="2" markerEnd="url(#arrowBlue3)" />
                <text x="640" y="122" fontSize="8" fill="#6b7280" fontWeight="500">READ</text>

                {/* === Row 2: Patients Management === */}
                <path d="M 120 95 L 150 95" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="77" width="130" height="35" rx="6" fill="#2CABCC" />
                <text x="225" y="99" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Patients Management</text>

                {/* Patients Management branches */}
                <line x1="290" y1="95" x2="350" y2="95" stroke="#9ca3af" strokeWidth="2" />
                <line x1="350" y1="95" x2="350" y2="175" stroke="#9ca3af" strokeWidth="2" />

                {/* CRUD Operation for Patients */}
                <line x1="350" y1="130" x2="400" y2="130" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="410" y="112" width="95" height="35" rx="6" fill="#22c55e" />
                <text x="457" y="134" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">CRUD Operation</text>

                {/* CRUD to main line */}
                <line x1="505" y1="130" x2="520" y2="130" stroke="#2CABCC" strokeWidth="2" />
                <text x="560" y="145" fontSize="8" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* Line to right components */}
                <line x1="620" y1="130" x2="750" y2="130" stroke="#2CABCC" strokeWidth="2" />
                <text x="700" y="122" fontSize="8" fill="#6b7280" fontWeight="500">READ</text>

                {/* Medical History */}
                <line x1="350" y1="175" x2="400" y2="175" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="410" y="157" width="95" height="35" rx="6" fill="#2CABCC" />
                <text x="457" y="179" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Medical History</text>

                {/* Medical History to main line */}
                <line x1="505" y1="175" x2="520" y2="175" stroke="#2CABCC" strokeWidth="2" />
                <text x="560" y="190" fontSize="8" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* Line to right */}
                <line x1="620" y1="175" x2="750" y2="175" stroke="#2CABCC" strokeWidth="2" />
                <text x="700" y="167" fontSize="8" fill="#6b7280" fontWeight="500">READ</text>
                <text x="760" y="190" fontSize="8" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* === Row 3: Approval Patient === */}
                <path d="M 120 220 L 150 220" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="202" width="95" height="35" rx="6" fill="#2CABCC" />
                <text x="207" y="224" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Approval Patient</text>

                <path d="M 255 220 L 290 220" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="300" y="202" width="95" height="35" rx="6" fill="#22c55e" />
                <text x="347" y="224" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Approve/Reject</text>

                {/* Approve/Reject to main line */}
                <line x1="395" y1="220" x2="520" y2="220" stroke="#2CABCC" strokeWidth="2" />
                <text x="450" y="212" fontSize="8" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* === Row 4: Service Management === */}
                <line x1="120" y1="340" x2="150" y2="340" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="322" width="115" height="35" rx="6" fill="#2CABCC" />
                <text x="217" y="344" textAnchor="middle" fontSize="9" fontWeight="600" fill="white">Service Management</text>

                <path d="M 275 340 L 290 340" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="300" y="322" width="95" height="35" rx="6" fill="#22c55e" />
                <text x="347" y="344" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">CRUD Operation</text>

                {/* Service CRUD to main line */}
                <line x1="395" y1="340" x2="520" y2="340" stroke="#2CABCC" strokeWidth="2" />
                <text x="450" y="332" fontSize="8" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* === Row 5: Dashboard/Analytics === */}
                <path d="M 120 400 L 150 400" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="382" width="125" height="35" rx="6" fill="#2CABCC" />
                <text x="222" y="404" textAnchor="middle" fontSize="9" fontWeight="600" fill="white">Dashboard/Analytics</text>

                {/* Dashboard to main line */}
                <line x1="285" y1="400" x2="520" y2="400" stroke="#2CABCC" strokeWidth="2" />
                <text x="400" y="392" fontSize="8" fill="#6b7280" fontWeight="500">READ</text>

                {/* === Row 6: Practitioners Management === */}
                <path d="M 120 460 L 150 460" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="442" width="115" height="40" rx="6" fill="#2CABCC" />
                <text x="217" y="458" textAnchor="middle" fontSize="9" fontWeight="600" fill="white">Practitioners</text>
                <text x="217" y="470" textAnchor="middle" fontSize="9" fontWeight="600" fill="white">Management</text>

                <line x1="275" y1="462" x2="290" y2="462" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="300" y="444" width="95" height="35" rx="6" fill="#22c55e" />
                <text x="347" y="466" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">CRUD Operation</text>

                {/* Practitioners CRUD to main line */}
                <line x1="395" y1="462" x2="520" y2="462" stroke="#2CABCC" strokeWidth="2" />
                <text x="450" y="454" fontSize="8" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* === Row 7: MBS Reviews === */}
                <path d="M 120 520 L 150 520" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="502" width="90" height="35" rx="6" fill="#2CABCC" />
                <text x="205" y="524" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">MBS Reviews</text>

                <path d="M 250 520 L 290 520" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="300" y="502" width="95" height="35" rx="6" fill="#22c55e" />
                <text x="347" y="524" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Approve/Reject</text>

                {/* MBS to main line */}
                <line x1="395" y1="520" x2="520" y2="520" stroke="#2CABCC" strokeWidth="2" />
                <text x="450" y="512" fontSize="8" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* === Row 8: Follow-ups === */}
                <path d="M 120 580 L 150 580" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="562" width="90" height="35" rx="6" fill="#2CABCC" />
                <text x="205" y="584" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Follow-ups</text>

                {/* Follow-ups to main line */}
                <line x1="250" y1="580" x2="520" y2="580" stroke="#2CABCC" strokeWidth="2" />
                <text x="380" y="572" fontSize="8" fill="#6b7280" fontWeight="500">READ</text>

                {/* === Row 9: Profile Settings === */}
                <path d="M 120 640 L 150 640" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray3)" />
                <rect x="160" y="622" width="100" height="35" rx="6" fill="#2CABCC" />
                <text x="210" y="644" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Profile Settings</text>

                {/* Profile Settings to main line */}
                <line x1="260" y1="640" x2="520" y2="640" stroke="#2CABCC" strokeWidth="2" />
                <text x="380" y="632" fontSize="8" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* Legend */}
                <rect x="20" y="680" width="10" height="10" rx="2" fill="#fbbf24" />
                <text x="35" y="689" fontSize="8" fill="#6b7280">Entry Point</text>

                <rect x="100" y="680" width="10" height="10" rx="2" fill="#2CABCC" />
                <text x="115" y="689" fontSize="8" fill="#6b7280">Module</text>

                <rect x="170" y="680" width="10" height="10" rx="2" fill="#22c55e" />
                <text x="185" y="689" fontSize="8" fill="#6b7280">Action</text>

                <rect x="230" y="680" width="10" height="10" rx="2" fill="#ef4444" />
                <text x="245" y="689" fontSize="8" fill="#6b7280">API</text>
            </svg>
        </div>
    );
}